import { FC, memo } from 'react'

import { Text } from '@cash-me/react-components'
import NextImage from "next/image"

import { Card } from 'components/card'
import { Grid, Col } from 'components/grid'
import { pushDataLayer } from 'utils/push-data-layer'

import * as S from './styles'

const ContactUs: FC = memo(() => {
  const handleClick = () => {
    pushDataLayer({
      category: 'Clique',
      action: 'Sou cliente',
      label: `Link E-mail Suporte a Pagamento`
    })
  }

  return (
    <S.ContactUs>
      <Grid col={{ phone: 1, tablet: 1 }}>
        <Col col={{ desktop: 10 }} start={{ desktop: 2 }}>
          <S.Infos>
            <Text color="var(--colors-neutral-text-default)" size="caption" weight="bold" uppercase>
              Atendimento ao cliente
            </Text>
            <Text as="h2" size="heading2" weight="medium">
              Precisa de ajuda?{' '}
              <Text as="span" size="heading2" weight="medium" color="var(--colors-pink-text-default)">
                Procure nossos canais de atendimento
              </Text>
            </Text>
          </S.Infos>
          <S.CardsWrapper>
            <Card>
              <S.CardContent>
                <S.IconImage>
                  <NextImage
                    src={`${process.env.NEXT_PUBLIC_SITE_IMAGES_PREFIX}/images/site/contact-us/icon/telephone.svg`}
                    alt="Telefone"
                    width="80"
                    height="80"
                    sizes="100vw"
                    style={{
                      width: "100%",
                      height: "auto"
                    }} />
                </S.IconImage>
                <Text size="body2" color="var(--colors-primary-background-strong-default)" weight="bold">
                  Telefone
                </Text>
                <Text size="body1" weight="medium" color="var(--colors-neutral-text-default)">
                  (11) 4040-2550
                </Text>
              </S.CardContent>
            </Card>
            <Card>
              <S.CardContent>
                <S.IconImage>
                  <NextImage
                    src={`${process.env.NEXT_PUBLIC_SITE_IMAGES_PREFIX}/images/site/duplicate-bill/icon/email.svg`}
                    alt="Email"
                    width="80"
                    height="80"
                    sizes="100vw"
                    style={{
                      width: "100%",
                      height: "auto"
                    }} />
                </S.IconImage>
                <Text size="body2" color="var(--colors-primary-background-strong-default)" weight="bold">
                  E-mail Suporte a Pagamento
                </Text>
                <div>
                  <a
                    onClick={() => handleClick()}
                    href="mailto:suporte.pagamento@cashme.com.br"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Text size="body1" weight="medium" color="var(--colors-neutral-text-default)">
                      suporte.pagamento@cashme.com.br
                    </Text>
                  </a>
                </div>
              </S.CardContent>
            </Card>
            <Card>
              <S.CardContent>
                <S.IconImage>
                  <NextImage
                    src={`${process.env.NEXT_PUBLIC_SITE_IMAGES_PREFIX}/images/site/duplicate-bill/icon/clock-contact-us.svg`}
                    alt="Relógio"
                    width="80"
                    height="80"
                    sizes="100vw"
                    style={{
                      width: "100%",
                      height: "auto"
                    }} />
                </S.IconImage>
                <Text size="body2" color="var(--colors-primary-background-strong-default)" weight="bold">
                  Horário de atendimento
                </Text>
                <Text size="body1" weight="medium" color="var(--colors-neutral-text-default)">
                  Segunda a Sexta feira das 9h às 17h
                </Text>
              </S.CardContent>
            </Card>
          </S.CardsWrapper>
        </Col>
      </Grid>
    </S.ContactUs>
  );
})

ContactUs.displayName = 'ContactUs'

export default ContactUs
